import { Input, Switch } from '@cokitchen/cokitchen-components';
import { AddIcon } from 'cokitchen-icons';
import React, { useEffect, useState } from 'react';
import PageHeaderText from 'components/base/page-header-text';
import CokitchenStatus from 'components/cokitchen-status';
import useCokitchenContext from 'contexts/cokitchen.context';
import './styles.scss';
import MultiInput from 'components/base/multi-input';
import AddressInput from 'components/address-input';

const CreateCokitchenKitchen = () => {
  const [addCutomerServiceWhatsapp, setAddCutomerServiceWhatsapp] = useState(false);
  const [addFrontDeskWhatsapp, setAddFrontDeskWhatsapp] = useState(false);
  const { createCokitchenForm, setCreateCokitchenForm, setDisabled } = useCokitchenContext();
  const [imageUrls, setImageUrls] = useState({
    event_image: createCokitchenForm.event_image ? [createCokitchenForm.event_image] : [],
    cover_images: createCokitchenForm.cover_images ? createCokitchenForm.cover_images : [],
    cover_videos: createCokitchenForm.cover_videos ? createCokitchenForm.cover_videos : []
  });
  const [latLng, setLatLng] = useState<{ lat: string; lng: string }>();

  const [cokitchenStatus, setCokitchenStatus] = useState<string>(
    createCokitchenForm.cokitchen_status
  );

  useEffect(() => {
    setCreateCokitchenForm({
      ...createCokitchenForm,
      cokitchen_status: cokitchenStatus,
      ...imageUrls,
      event_image: imageUrls.event_image[0]
    });
  }, [imageUrls]);

  useEffect(() => {
    if (
      createCokitchenForm.name &&
      createCokitchenForm.address &&
      createCokitchenForm.customer_service_phone_number?.[0]
    ) {
      setDisabled(false);
    } else {
      setDisabled(true);
    }
  }, [createCokitchenForm]);

  useEffect(() => {
    setCreateCokitchenForm({
      ...createCokitchenForm,
      cokitchen_status: cokitchenStatus
    });
  }, [cokitchenStatus]);

  useEffect(() => {
    if (latLng?.lat && latLng?.lng)
      setCreateCokitchenForm({
        ...createCokitchenForm,
        lat: latLng.lat,
        lng: latLng.lng
      });
  }, [latLng]);

  const handleCsNumberDelete = (value: string) =>
    setCreateCokitchenForm({
      ...createCokitchenForm,
      customer_service_phone_number: createCokitchenForm.customer_service_phone_number.filter(
        (num) => num !== value
      )
    });

  const handleCsNumberChange = (value: string) => {
    if (value?.length > 10) {
      setCreateCokitchenForm({
        ...createCokitchenForm,
        customer_service_phone_number: [...createCokitchenForm.customer_service_phone_number, value]
      });
      return true;
    }
  };

  const handleCsWhatsAppDelete = (value: string) =>
    setCreateCokitchenForm({
      ...createCokitchenForm,
      customer_service_whatsapp: createCokitchenForm.customer_service_whatsapp.filter(
        (num) => num !== value
      )
    });

  const handleCsWhatsAppChange = (value: string) => {
    if (value?.length > 10) {
      setCreateCokitchenForm({
        ...createCokitchenForm,
        customer_service_whatsapp: [...createCokitchenForm.customer_service_whatsapp, value]
      });
      return true;
    }
  };

  const handleFdNumberDelete = (value: string) =>
    setCreateCokitchenForm({
      ...createCokitchenForm,
      frontdesk_phone_number: createCokitchenForm.frontdesk_phone_number.filter(
        (num) => num !== value
      )
    });

  const handleFdNumberChange = (value: string) => {
    if (value?.length > 10) {
      setCreateCokitchenForm({
        ...createCokitchenForm,
        frontdesk_phone_number: [...createCokitchenForm.frontdesk_phone_number, value]
      });
      return true;
    }
  };

  const handleFdWhatsAppDelete = (value: string) =>
    setCreateCokitchenForm({
      ...createCokitchenForm,
      frontdesk_whatsapp: createCokitchenForm.frontdesk_whatsapp.filter((num) => num !== value)
    });

  const handleFdWhatsAppChange = (value: string) => {
    if (value?.length > 10) {
      setCreateCokitchenForm({
        ...createCokitchenForm,
        frontdesk_whatsapp: [...createCokitchenForm.frontdesk_whatsapp, value]
      });
      return true;
    }
  };

  const validateNumber = (value: string) => value === '' || !isNaN(Number(value));

  return (
    <div className='flex flex-col space-y-4 kitchen_form'>
      <PageHeaderText title='Create cokitchen' description='Add a new kitchen to the team' />
      <Input
        small
        type='text'
        label='Cokitchen Name'
        placeholder='Enter cokitchen name'
        value={createCokitchenForm.name}
        onChange={(e) => setCreateCokitchenForm({ ...createCokitchenForm, name: e.target.value })}
      />

      <AddressInput
        label='Cokitchen Address'
        placeholder='Enter address'
        address={createCokitchenForm.address}
        setAddress={(e: any) => setCreateCokitchenForm({ ...createCokitchenForm, address: e })}
        setLatLng={setLatLng}
      />
      <Input
        small
        type='text'
        label='Cokitchen Tagline'
        placeholder='Enter Tagline'
        value={createCokitchenForm?.description}
        onChange={(e) =>
          setCreateCokitchenForm({ ...createCokitchenForm, description: e.target.value })
        }
      />

      <CokitchenStatus
        cokitchenStatus={cokitchenStatus}
        setCokitchenStatus={setCokitchenStatus}
        imageUrls={imageUrls}
        setImageUrls={setImageUrls}
      />
      <MultiInput
        label='Customer Service Number'
        placeholder='000 0000 0000'
        values={createCokitchenForm.customer_service_phone_number}
        onDelete={handleCsNumberDelete}
        onChange={handleCsNumberChange}
        validate={validateNumber}
      />
      {!addCutomerServiceWhatsapp && (
        <div
          className='flex gap-1 text-[#0080E5] items-center font-medium cursor-pointer'
          onClick={() => setAddCutomerServiceWhatsapp(true)}>
          <AddIcon className='w-5 h-5' />
          <span>Add customer service WhatsApp</span>
        </div>
      )}
      {addCutomerServiceWhatsapp && (
        <MultiInput
          label='Customer Service Number (Whatsapp)'
          placeholder='000 0000 0000'
          values={createCokitchenForm.customer_service_whatsapp}
          onDelete={handleCsWhatsAppDelete}
          onChange={handleCsWhatsAppChange}
          validate={validateNumber}
        />
      )}
      <MultiInput
        label='Front Desk Number'
        placeholder='000 0000 0000'
        values={createCokitchenForm.frontdesk_phone_number}
        onDelete={handleFdNumberDelete}
        onChange={handleFdNumberChange}
        validate={validateNumber}
      />
      {!addFrontDeskWhatsapp && (
        <div
          className='flex gap-1 text-[#0080E5] items-center font-medium cursor-pointer'
          onClick={() => setAddFrontDeskWhatsapp(true)}>
          <AddIcon className='w-5 h-5' />
          <span>Add front desk WhatsApp</span>
        </div>
      )}
      {addFrontDeskWhatsapp && (
        <div className='flex flex-col gap-2'>
          <MultiInput
            label='Front Desk Number (Whatsapp)'
            placeholder='000 0000 0000'
            values={createCokitchenForm.frontdesk_whatsapp}
            onDelete={handleFdWhatsAppDelete}
            onChange={handleFdWhatsAppChange}
            validate={validateNumber}
          />
        </div>
      )}
      <Switch
        active={createCokitchenForm.active}
        onChange={(e) => setCreateCokitchenForm({ ...createCokitchenForm, active: e })}
        label='Cokitchen Status:'
      />
    </div>
  );
};

export default CreateCokitchenKitchen;
